"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AI_RESPONSE_POLL_INTERVAL = 3000;
var AI_RESPONSE_MAX_POLL_ATTEMPTS = 40;
var AiChatStore = /*#__PURE__*/function (_RootStore) {
  function AiChatStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, AiChatStore);
    _this = _callSuper(this, AiChatStore);
    _this.config = {
      model: _models.AiChat,
      deserialize: true,
      GET: {
        index: '/worksheets/:worksheetId/ai_chats',
        show: '/worksheets/:worksheetId/ai_chats/:aiChatId'
      },
      POST: {
        create: '/worksheets/:worksheetId/ai_chats',
        message: '/worksheets/:worksheetId/ai_chats/:aiChatId/messages'
      },
      MULTIPART_POST: {
        create: '/worksheets/:worksheetId/ai_chats',
        message: '/worksheets/:worksheetId/ai_chats/:aiChatId/messages'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(AiChatStore, _RootStore);
  return (0, _createClass2["default"])(AiChatStore, [{
    key: "create",
    value: function create(params, callback) {
      this.api(params, callback, 'POST', 'create');
    }
  }, {
    key: "multipartCreate",
    value: function multipartCreate(params, callback) {
      this.api(params, callback, 'MULTIPART_POST', 'create');
    }
  }, {
    key: "message",
    value: function message(params, callback) {
      this.apiWithTimeoutPolling(params, callback, 'POST', 'message');
    }
  }, {
    key: "multipartMessage",
    value: function multipartMessage(params, callback) {
      this.apiWithTimeoutPolling(params, callback, 'MULTIPART_POST', 'message');
    }
  }, {
    key: "apiWithTimeoutPolling",
    value: function apiWithTimeoutPolling(params, callback, routeVerb, routeAction) {
      var _this$showData,
        _this2 = this;
      var initialMessagesCount = ((_this$showData = this.showData) === null || _this$showData === void 0 || (_this$showData = _this$showData.aiChatMessages) === null || _this$showData === void 0 ? void 0 : _this$showData.length) || 0;
      this.api(_objectSpread(_objectSpread({}, params), {}, {
        onRequestError: function onRequestError(error) {
          if (_this2.requestTimedOut(error)) {
            _this2.pollShowUntilAiResponse(params, callback, initialMessagesCount);
          } else if (params.onRequestError) {
            params.onRequestError(error);
          } else {
            _this2.onFailure(error);
          }
        }
      }), callback, routeVerb, routeAction);
    }
  }, {
    key: "requestTimedOut",
    value: function requestTimedOut(error) {
      var _error$message;
      return (error === null || error === void 0 ? void 0 : error.timeout) || (error === null || error === void 0 ? void 0 : error.code) === 'ECONNABORTED' || (error === null || error === void 0 ? void 0 : error.errno) === 'ETIME' || (error === null || error === void 0 || (_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.toLowerCase().includes('timeout'));
    }
  }, {
    key: "pollShowUntilAiResponse",
    value: function pollShowUntilAiResponse(params, callback, initialMessagesCount) {
      var _this3 = this;
      var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      if (attempt >= AI_RESPONSE_MAX_POLL_ATTEMPTS) {
        if (params.onRequestError) {
          params.onRequestError();
        }
        return;
      }
      setTimeout(function () {
        _this3.getShow({
          ids: params.ids
        }, function (resp) {
          if (_this3.latestMessageIsAiResponse(resp, initialMessagesCount)) {
            callback(resp);
          } else {
            _this3.pollShowUntilAiResponse(params, callback, initialMessagesCount, attempt + 1);
          }
        }, {
          onRequestError: function onRequestError() {
            return _this3.pollShowUntilAiResponse(params, callback, initialMessagesCount, attempt + 1);
          }
        });
      }, AI_RESPONSE_POLL_INTERVAL);
    }
  }, {
    key: "latestMessageIsAiResponse",
    value: function latestMessageIsAiResponse(resp, initialMessagesCount) {
      var messages = resp.aiChatMessages || [];
      var latestMessage = messages[messages.length - 1];
      return messages.length > initialMessagesCount && latestMessage && !latestMessage.userId;
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new AiChatStore();